// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_SalvarAtributosCategoriaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/report_attributes/salvar_atributos_categoria/{category_id}
 *
 * Bulk replaces the list of report attributes bound to a service category.
 *
 * Required:
 *   - attributes (So_CategoryAttributeBindingInputRow[]) — each entry must
 *     contain attribute_id and a report_type of 'entry' | 'exit' | 'both'.
 */
import type { So_CategoryAttributeBindingInputRow } from './So_CategoryAttributeBindingInputRow'
import { registerContract } from './validate'

export interface Report_attributes_SalvarAtributosCategoriaInput {
attributes?: So_CategoryAttributeBindingInputRow[]
}

registerContract('Report_attributes_SalvarAtributosCategoriaInput', {
  attributes: {
    type: 'array',
    required: false,
    items: {
      attribute_id:   { type: 'number',  required: true },
      required:       { type: 'number',  required: false },
      display_order:  { type: 'number',  required: false },
      report_type:    { type: 'string',  required: false },
      is_description: { type: 'number',  required: false },
    },
  },
})
